const truncate = (str, wordCount, ellipsis = '...') => {
  let aStr = str.split(' ');
  if (aStr.length <= wordCount) {
    return str;
  }
  return `${aStr.splice(0, wordCount).join(' ')}${ellipsis}`;
};

export default truncate;
